export const showOnbordingLabel = (
  onboardingLabel,
  experiments,
  removeOnboardingLabels = []
) => {
  if (experiments?.removeTagsOnboarding === 'a') {
    return false;
  }
  if (
    experiments?.removeTagsOnboarding === 'c' &&
    removeOnboardingLabels?.includes(onboardingLabel)
  ) {
    return false;
  }
  return true;
};
